import React, { useEffect, useState } from "react";
import "./Tabs.scss";
import UnitDetailsForm from "./UnitDetailsForm";
import OffSiteActivityForm from "./OffSiteActivityForm";
import { AuditData } from "../../data/AuditData";
import Snackbar from "@mui/material/Snackbar";
import { useParams } from "react-router-dom";

import {
  auditSaveData,
  formId,
  formProgress,
  savedLoading,
  submitLoading,
  unitDetailDisableButton,
  unitDetailsSubmitAtom,
} from "../../../store/atoms";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { editData } from "../../../store/selectors";
import { getToken } from "../../auth/authConfig";
import { Alert, Box } from "@mui/material";
import { login } from "../../auth/msalAuth";

const CustomTabs = ({ setUnitIndexValue }) => {
  const [unitDetailsTrue, setUnitDetailsTrue] = useState(true);
  const [unitData, setUnitData] = useRecoilState(auditSaveData);
  // console.log("unintopdata", unitData);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const setSubmit = useSetRecoilState(unitDetailsSubmitAtom);
  const [buttonsDisable, setButtonsDisable] = useRecoilState(
    unitDetailDisableButton
  );
  const setSavedButtonLoading = useSetRecoilState(savedLoading);
  const setSubmitButtonLoading = useSetRecoilState(submitLoading);
  const progressUpdate = useSetRecoilState(formProgress);
  const navigate = useNavigate();
  const formIdValue = useRecoilValue(formId);
  const saveApiUrl = `${process.env.REACT_APP_SERVER_URL}/form/submit`;

  const queryParams = new URLSearchParams(window.location.search);
  const auditNumber = queryParams.get("auditNumber");
  const [error, setError] = useState(false);
  
  // State for API data loading
  const [apiDataLoaded, setApiDataLoaded] = useState(false);
  const [loading, setLoading] = useState(false);

  // Fetch data for both Unit Details and Off-Site forms
  const fetchFormData = async () => {
    if (!auditNumber) return;
    
    try {
      setLoading(true);
      const token = await getToken();
      const apiUrl = `${process.env.REACT_APP_SERVER_URL}/form/ud/${auditNumber}`;
      
      const { data } = await axios.get(apiUrl, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });
      
      if (data) {
        // Set both unitDetails and offSiteFields in Recoil state
        setUnitData({
          unitDetails: data?.unitDetails || [],
          offSiteFields: data?.offSiteFields || [],
        });
        setApiDataLoaded(true);
      }
    } catch (e) {
      console.log("error while getting the form data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFormData();
  }, [auditNumber]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  function normalizeValue(value) {
    if (typeof value === "string" && value.trim() !== "") {
      // Ensure it's a non-empty string
      if (!(value.startsWith("[") && value.endsWith("]"))) {
        value = `["${value.replace(/"/g, '\\"')}"]`; // Wrap it inside an array, escape quotes
      }
      return value; // Convert string to an array
    }
    return `[]`; // Return an empty array if value is empty
  }
  const saveFormData = async (check) => {
    try {
      const token = await getToken();
      if (check === "next") {
        setSubmitButtonLoading(true);
      } else {
        setSavedButtonLoading(true);
      }

      setSnackbarMessage("Form Saved Successfully!");
      const unitDetailsValues = unitData?.unitDetails;
      const updatedUnitDetailsValues = unitDetailsValues.map((item) => {
        if (item.name === "certifications") {
          // Return a new object with the updated value for certifications
          return { ...item, value: normalizeValue(item.value) };
        }
        return item; // Keep other items unchanged
      });

      // console.log("checking....", unitData);
      const savePayload = {
        formId: auditNumber ? auditNumber : formIdValue,
        unitDetails: updatedUnitDetailsValues,
        offSiteFields: unitData?.offSiteFields,
        status: "Active",
        activity: "saved",
      };
      const { data } = await axios.post(saveApiUrl, savePayload, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });
      if (data?.message) {
        if (check === "next") {
          setSubmitButtonLoading(false);
        }
        setSavedButtonLoading(false);
        if (check !== "new") {
          setOpen(true);
        }
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }

      setSavedButtonLoading(false);
      setSubmitButtonLoading(false);

      if (check === "next") {
        setSubmitButtonLoading(false);
      }
      setSubmitButtonLoading(false);
      console.log("Internal Sever Errro while saving the form");
    }
  };
  const submitForm = async () => {
    try {
      const token = await getToken();
      setSubmitButtonLoading(true);
      setSnackbarMessage("Form Submitted Successfully!");
      console.log("unitData?.unitDetails", unitData?.unitDetails);
      const unitDetailsValues = unitData?.unitDetails;
      const updatedUnitDetailsValues = unitDetailsValues.map((item) => {
        if (item.name === "certifications") {
          // Return a new object with the updated value for certifications
          return { ...item, value: normalizeValue(item.value) };
        }
        return item; // Keep other items unchanged
      });

      const savePayload = {
        formId: auditNumber ? auditNumber : formIdValue,
        unitDetails: updatedUnitDetailsValues,
        offSiteFields: unitData?.offSiteFields,
        status: "Active",
        activity: "completed",
      };
      const { data } = await axios.post(saveApiUrl, savePayload, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });
      if (data?.message) {
        const resetData = {
          unitDetails: [],
          offSiteFields: [],
        };
        setSubmitButtonLoading(false);
        setSubmit(true);
        setUnitData(resetData);
        progressUpdate((prev) => prev + 1);
        setTimeout(() => {
          setSubmit(false);
          navigate("/");
        }, 2000);
      }
    } catch (e) {

      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      // setError(true);
      // setTimeout(() => {
      //   setError(false);
      //   login();
      // }, 3000);
      setSubmitButtonLoading(false);
      // setError(true);
      setSavedButtonLoading(false);
      console.log("Internal Sever Errro while saving the form");
    }
  };

  const handleUnitDetails = () => {
    if (!unitDetailsTrue) {
      const offsiteElement = document.querySelector(".tab-right");
      const unitElement = document.querySelector(".tab-left");
      offsiteElement.classList.remove("tab-active");
      unitElement.classList.add("tab-active");
      setUnitDetailsTrue(true);
      // No API call - just switch tabs
    }
  };
  const handleOffsiteActivity = () => {
    if (unitDetailsTrue) {
      const offsiteElement = document.querySelector(".tab-right");
      const unitElement = document.querySelector(".tab-left");
      offsiteElement.classList.add("tab-active");
      unitElement.classList.remove("tab-active");
      setUnitDetailsTrue(false);
      // No API call - just switch tabs
    }
  };

  // useEffect(() => {}, [initialValue]);
  // console.log("initial value", initialValue);

  return (
    <>
      <div id="custom-tabs">
        <button
          disabled={buttonsDisable}
          onClick={handleUnitDetails}
          className="tab-left tab-active "
        >
          Unit Details
        </button>
        <button
          disabled={buttonsDisable}
          onClick={handleOffsiteActivity}
          className=" tab-right"
        >
          Off-Site Activities{" "}
        </button>
      </div>
      {unitDetailsTrue ? (
        <UnitDetailsForm
          handleOffsiteActivity={handleOffsiteActivity}
          saveFormData={saveFormData}
          setUnitIndexValue={setUnitIndexValue}
          loading={loading}
          apiDataLoaded={apiDataLoaded}
        />
      ) : (
        <OffSiteActivityForm
          saveFormData={saveFormData}
          submitForm={submitForm}
          loading={loading}
          apiDataLoaded={apiDataLoaded}
        />
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        onClose={handleClose}
        message={snackbarMessage}
        autoHideDuration={3000}
        className="success-snackbar"
      />
      {error && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default CustomTabs;
